import {styled} from "@mui/material";


const isSmallScreen = window.innerWidth < 520;
const isMediumScreen = window.innerWidth <= 620;
const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 0),
    marginTop: isSmallScreen ? '40px' : isMediumScreen ? '24px' : '0px',
    ...theme.mixins.toolbar,
}));

export default DrawerHeader;
